if (document.querySelector('.section').classList.contains('useparallax')) {
  window.addEventListener('scroll', function() {
    const scrollTop = window.pageYOffset,
    bgPosition = scrollTop / 3 + 'px';
    document.querySelector('.useparallax').style.backgroundPosition =  'top ' + bgPosition + ' center';
  });
}
